export default [
    {
        name: '__checkbox',
        titleClass: 'center aligned',
        dataClass: 'center aligned'
    },
    {
        name: 'name',
        /*sortField: 'name',*/
        type: 'string',
        callback: 'domain',
        defaultSearch: true,
        useInFilter: true,
    },
    {
        name: 'topkeys',
        /*sortField: 'topkeys',*/
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
        isDefault: true
    },
    {
        name: 'it1',
        /*sortField: 'it1',*/
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'it3',
        /*sortField: 'it3',*/
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'it5',
        /*sortField: 'it5',*/
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'it10',
        /*sortField: 'it10',*/
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: '__slot:it50',
        /*sortField: 'it50',*/
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'pagesinindex',
        /*sortField: 'pagesinindex',*/
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'adscnt',
        /*sortField: 'adscnt',*/
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'adkeyscnt',
        /*sortField: 'adkeyscnt',*/
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'adtraf',
        /*sortField: 'adtraf',*/
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: false,
    },
    {
        name: 'adcost',
        /*sortField: 'adcost',*/
        type: 'number',
        callback: 'currency',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: false,
        engine: "yandex",

    }
]
